export const FIND_RENUNCIA_RECEITAS = 'FIND_RENUNCIA_RECEITAS';
export const FIND_RENUNCIA_RECEITAS_START = 'FIND_RENUNCIA_RECEITAS_START';
export const FIND_RENUNCIA_RECEITAS_SUCCESS = 'FIND_RENUNCIA_RECEITAS_SUCCESS';
export const FIND_RENUNCIA_RECEITAS_ERROR = 'FIND_RENUNCIA_RECEITAS_ERROR';

export const ANISTIA = 'ANISTIA';
export const REMISSAO = 'REMISSAO';
export const SUBSIDIO = 'SUBSIDIO';
export const CREDITO_PRESUMIDO = 'CREDITO_PRESUMIDO';
export const ISENCAO = 'ISENCAO';
export const CADUCIDADE = 'CADUCIDADE';

export const RenunciaReceitas = [
  { label: 'Anistia', tipo: ANISTIA },
  { label: 'Remissão', tipo: REMISSAO },
  { label: 'Subsídio', tipo: SUBSIDIO },
  { label: 'Crédito Presumido', tipo: CREDITO_PRESUMIDO },
  { label: 'Isenção', tipo: ISENCAO },
  { label: 'Caducidade', tipo: CADUCIDADE }
];
